import { ReactNode } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import MainLayout from '@/layouts/MainLayout/MainLayout.tsx';
import FlexBlock from '@/components/ui/FlexBlock/FlexBlock.tsx';
import CloseIcon from '@/assets/Icons/Close.svg?react';
import { Logo } from '@/components/Logo/Logo.tsx';
import Image from '@/components/ui/Image/Image.tsx';
import Card from '@/components/ui/Card/Card.tsx';
import styles from './OrganizationLoginLayout.module.scss';
import GetOrganizationPageResponse = App.Data.Response.GetOrganizationPageResponse;

interface OrganizationLoginLayoutProps {
	data?: GetOrganizationPageResponse;
	message?: string | null;
	organizationLogoClassName?: string;
	children: ReactNode;
}

const OrganizationLoginLayout = ({
	data,
	message,
	organizationLogoClassName,
	children,
}: OrganizationLoginLayoutProps) => (
	<MainLayout>
		<title>Login | Goodwings - Compromise free travel</title>
		<FlexBlock
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
			rowGap="32px"
			className={styles.loginPageWrapper}
		>
			<div className={styles.loginCardWrapper}>
				{data && (
					<FlexBlock justifyContent="center" alignItems="center" className={styles.logos}>
						<Logo showOnlyName />
						{data.logoUrl && (
							<>
								<CloseIcon />
								<div className={classNames(styles.organizationLogo, organizationLogoClassName)}>
									<Image src={data.logoUrl} fallbackSrc="" alt="Organization logo" />
								</div>
							</>
						)}
					</FlexBlock>
				)}
				{!!message && <p className={styles.additionalMessage}>{message}</p>}
				<Card className={styles.card}>{children}</Card>
			</div>
			{data && (
				<FlexBlock justifyContent="space-between" columnGap="6px" className={styles.moreInfo}>
					{data.travelPolicyUrl && (
						<Link to={data.travelPolicyUrl} target="_blank">
							Travel Policy
						</Link>
					)}
					{data.videoGuidelinesUrl && (
						<Link to={data.videoGuidelinesUrl} target="_blank">
							Video Guidelines
						</Link>
					)}
					{data.faqUrl && (
						<Link to={data.faqUrl} target="_blank">
							FAQ
						</Link>
					)}
				</FlexBlock>
			)}
		</FlexBlock>
	</MainLayout>
);

export default OrganizationLoginLayout;
